import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useViewport } from 'utils'

//apis
import DashboardAPI from 'apis/dashboard'

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Lazy, Navigation } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// styles
import styles from './index.module.scss'
import HomeNftCard from 'components/Card/HomeNFTCard'
import LiveAuctionCard from 'components/Card/LiveAuctionCard'
import HomeEditionCard from 'components/Card/HomeEditionCard'
const NFTMoreSection = props => {
  const { wallet, username, nftAddress } = props
  const viewport = useViewport()
  const router = useRouter()
  const [nftList, setNftList] = useState([])

  useEffect(() => {
    let params = {
      sort: 'price-descending',
      page: 1,
      per_page: 'all',
    }
    params['ownership'] = 'created'
    DashboardAPI.getArtworkList(wallet, params, false).then(
      response => {
        setNftList(
          response.filter(
            item =>
              item.tokenId !== nftAddress && (item.assetUrl.includes('http://') || item.assetUrl.includes('https://'))
          )
        )
      },
      error => {}
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallet])

  return (
    nftList.length > 0 && (
      <div className="w-full ">
        <div className={`w-full flex justify-between items-center ${viewport === 'xs' ? 'ml-[25px]' : 'g-container'}`}>
          <div className={styles.caption}>{'More from ' + username}</div>
          {nftList.length > 5 && viewport !== 'xs' && (
            <div
              className={styles.seeMore}
              onClick={() => {
                router.push(`/${username.replaceAll(' ', '%20')}`)
              }}
            >
              {'See More'}
            </div>
          )}
        </div>
        <div className="w-full sm:block hidden mt-[30px] g-container">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-[20px] lg:gap-[20px] xl:gap-[30px]">
            {nftList.slice(0, 5).map((item, index) => {
              return item.auction ? (
                <LiveAuctionCard
                  data={{
                    token_id: item.tokenId,
                    nft_name: item.nftName,
                    asset_url: item.assetUrl,
                    artist_username: item.artistUsername,
                    asset_type: item.assetType,
                    artist_profile_picture: item.artistProfilePicture,
                    cover_image_url: item.coverImageUrl,
                    current_bid: item.currentBid,
                    reserve_price: item.auction?.reserve_price,
                    start_time: item.auction?.start_time,
                    end_time: item.auction?.end_time,
                    parent_nft: item.parentNft,
                    max_supply: item.maxSupply,
                  }}
                  onClick={() => {}}
                  setCardExpired={item => {}}
                  key={index}
                />
              ) : item.masterEdition ? (
                <HomeEditionCard
                  data={{
                    tokenId: item.tokenId,
                    nftName: item.nftName,
                    artistUsername: item.artistUsername,
                    artistProfilePicture: item.artistProfilePicture,
                    coverImageUrl: item.coverImageUrl,
                    assetUrl: item.assetUrl,
                    endTime: item.masterEdition?.endTime,
                    startTime: item.masterEdition?.startTime,
                    price: item.masterEdition?.price,
                    currentSupply: item.currentSupply,
                    maxSupply: item.maxSupply,
                  }}
                  type={item.maxSupply === null ? 'open' : 'limit'}
                  onClick={() => {}}
                  key={index}
                />
              ) : (
                <HomeNftCard
                  image={item.assetUrl}
                  token_id={item.tokenId}
                  nftName={item.nftName}
                  assetType={item.assetType}
                  coverImage={item.coverImageUrl}
                  artistName={item.artistUsername}
                  artistImage={item.artistProfilePicture}
                  collectionName={item.collectionName}
                  price={item.listPrice}
                  parentNft={item.parentNft}
                  currentSupply={item.currentSupply}
                  maxSupply={item.maxSupply}
                  onClick={() => {}}
                  key={index}
                />
              )
            })}
          </div>
        </div>
        <div className="w-full sm:hidden block mt-[30px]">
          <Swiper
            navigation={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? true : false}
            slidesPerView={
              viewport === 'xs'
                ? 1.41
                : viewport === 'sm'
                ? 1.92
                : viewport === 'md'
                ? 2
                : viewport === '2xl'
                ? 5
                : viewport === 'xl'
                ? 4
                : 4
            }
            spaceBetween={
              viewport === 'xs' ? 20 : viewport === 'sm' || viewport === 'md' ? 30 : viewport === 'lg' ? 30 : 30
            }
            centeredSlides={viewport === 'xs'}
            loop={viewport === 'xs' && nftList.length > 2}
            modules={[Autoplay, Lazy, Navigation]}
            className={'noScrollNavigationSwiper'}
          >
            {nftList.slice(0, 5).map((item, index) => (
              <SwiperSlide key={index}>
                {item.auction ? (
                  <LiveAuctionCard
                    data={{
                      token_id: item.tokenId,
                      nft_name: item.nftName,
                      asset_url: item.assetUrl,
                      artist_username: item.artistUsername,
                      asset_type: item.assetType,
                      artist_profile_picture: item.artistProfilePicture,
                      cover_image_url: item.coverImageUrl,
                      current_bid: item.currentBid,
                      reserve_price: item.auction?.reserve_price,
                      start_time: item.auction?.start_time,
                      end_time: item.auction?.end_time,
                      parent_nft: item.parentNft,
                      max_supply: item.maxSupply,
                    }}
                    onClick={() => {}}
                    setCardExpired={item => {}}
                    key={index}
                  />
                ) : item.masterEdition ? (
                  <HomeEditionCard
                    data={{
                      tokenId: item.tokenId,
                      nftName: item.nftName,
                      artistUsername: item.artistUsername,
                      artistProfilePicture: item.artistProfilePicture,
                      coverImageUrl: item.coverImageUrl,
                      assetUrl: item.assetUrl,
                      endTime: item.masterEdition?.endTime,
                      startTime: item.masterEdition?.startTime,
                      price: item.masterEdition?.price,
                      currentSupply: item.currentSupply,
                      maxSupply: item.maxSupply,
                    }}
                    type={item.maxSupply === null ? 'open' : 'limit'}
                    onClick={() => {}}
                    key={index}
                  />
                ) : (
                  <HomeNftCard
                    image={item.assetUrl}
                    token_id={item.tokenId}
                    nftName={item.nftName}
                    assetType={item.assetType}
                    coverImage={item.coverImageUrl}
                    artistName={item.artistUsername}
                    artistImage={item.artistProfilePicture}
                    collectionName={item.collectionName}
                    price={item.listPrice}
                    parentNft={item.parentNft}
                    currentSupply={item.currentSupply}
                    maxSupply={item.maxSupply}
                    onClick={() => {}}
                    key={index}
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    )
  )
}

export default NFTMoreSection
